import React, { useState, useEffect, useRef } from 'react'
import { ContentAreaProps } from '../ContentArea/ContentArea'

const useCalculateHeights = (
  contentArea: ContentAreaProps[],
  isSmall: boolean,
  headlineSelector: string,
  contentSelector: string
) => {
  const refs = useRef<Array<React.RefObject<HTMLElement>>>(
    contentArea ? contentArea.map(() => React.createRef<HTMLElement>()) : []
  )
  const [biggestHeadlineHeight, setBiggestHeadlineHeight] = useState(0)
  const [biggestContentHeight, setBiggestContentHeight] = useState(0)

  useEffect(() => {
    const calculateHeights = () => {
      if (isSmall && refs) {
        refs.current.forEach(item => {
          const headline = item.current?.querySelector(headlineSelector)
          const content = item.current?.querySelector(contentSelector)

          if (headline instanceof HTMLElement) {
            headline.style.height = 'auto'
          }
          if (content instanceof HTMLElement) {
            content.style.height = 'auto'
          }
        })

        const headlineHeights = refs.current.map(
          item =>
            item.current?.querySelector(headlineSelector)?.clientHeight ?? 0
        )
        const biggestHeadlineHeight = Math.max(...headlineHeights)
        setBiggestHeadlineHeight(biggestHeadlineHeight)

        const contentHeights = refs.current.map(
          item =>
            item.current?.querySelector(contentSelector)?.clientHeight ?? 0
        )
        const biggestContentHeight = Math.max(...contentHeights)
        setBiggestContentHeight(biggestContentHeight)
      }
    }

    calculateHeights()
    window.addEventListener('resize', calculateHeights)

    return () => {
      window.removeEventListener('resize', calculateHeights)
    }
  }, [refs, isSmall])

  return { biggestHeadlineHeight, biggestContentHeight, refs }
}

export default useCalculateHeights
